import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from '../Ant';
import ClosableModal from '../closableModal/closableModal';
import AppearanceSettings from '../profile/appearanceSettings';

interface IAppearanceSetupModalProps {
  open: boolean;
  onClose: () => void;
}

/** Each change applies as soon as it is picked, so the dialog stays open until Done. */
const AppearanceSetupModal = ({ open, onClose }: IAppearanceSetupModalProps) => {
  const { t } = useTranslation();

  return (
    <ClosableModal
      title={t('common:profile.appearance')}
      subtitle={t('common:profile.appearanceSetupDescription')}
      open={open}
      onClose={onClose}
      data-testid="appearance-setup-modal"
    >
      <Flex vertical gap={15}>
        <AppearanceSettings />
        <Button
          type="primary"
          size="large"
          block
          onClick={onClose}
          data-testid="appearance-done-button"
        >
          {t('common:done')}
        </Button>
      </Flex>
    </ClosableModal>
  );
};

export default AppearanceSetupModal;
